import { Modal } from "antd"

interface BaseModalProps {
  isOpen: boolean
  onClose: () => void
  title?: React.ReactNode
  children: React.ReactNode
  width?: number
  centered?: boolean
  style?: React.CSSProperties
  closeIcon?: React.ReactNode
  transitionName?: string
}
  
export const BaseModal: React.FC<BaseModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  width = 520,
  ...props
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={title}
      width={width}
      footer={null}
      destroyOnClose
      {...props}
    >
      {children}
    </Modal>
  )
}